#import "./BarMitzvahDetails.graphql"
query BarMitzvahQuery($id: ID!) {
  barMitzvah(id: $id) {
    ...barMitzvahDetails
  }
}
